import clsx from 'clsx';
import { PropsWithChildren } from 'react';

type ContainerProps = PropsWithChildren<{
  className?: string;
}>;

export function Container({ className, children }: ContainerProps) {
  return <div className={clsx('flex flex-col w-full max-w-(--container-xl) mx-auto px-md', className)}>{children}</div>;
}
